module.exports = __webpack_public_path__ + "static/media/CY.59aa3a04.svg";